var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 11.0001C4.76663 11.9167 5.86663 12.8334 8.24996 12.8334C12.8333 12.8334 12.8333 9.16675 17.4166 9.16675C19.8 9.16675 20.9 10.0834 22 11.0001C23.1 11.9167 24.2 12.8334 26.5833 12.8334C31.1666 12.8334 31.1666 9.16675 35.75 9.16675C38.1333 9.16675 39.2333 10.0834 40.3333 11.0001M3.66663 33.0001C4.76663 33.9167 5.86663 34.8334 8.24996 34.8334C12.8333 34.8334 12.8333 31.1667 17.4166 31.1667C19.8 31.1667 20.9 32.0834 22 33.0001C23.1 33.9167 24.2 34.8334 26.5833 34.8334C31.1666 34.8334 31.1666 31.1667 35.75 31.1667C38.1333 31.1667 39.2333 32.0834 40.3333 33.0001M3.66663 22.0001C4.76663 22.9167 5.86663 23.8334 8.24996 23.8334C12.8333 23.8334 12.8333 20.1667 17.4166 20.1667C19.8 20.1667 20.9 21.0834 22 22.0001C23.1 22.9167 24.2 23.8334 26.5833 23.8334C31.1666 23.8334 31.1666 20.1667 35.75 20.1667C38.1333 20.1667 39.2333 21.0834 40.3333 22.0001",
    stroke: "#448B7E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 13.8333C4.76663 14.75 5.86663 15.6667 8.24996 15.6667C12.8333 15.6667 12.8333 12 17.4166 12C19.8 12 20.9 12.9167 22 13.8333C23.1 14.75 24.2 15.6667 26.5833 15.6667C31.1666 15.6667 31.1666 12 35.75 12C38.1333 12 39.2333 12.9167 40.3333 13.8333M3.66663 35.8333C4.76663 36.75 5.86663 37.6667 8.24996 37.6667C12.8333 37.6667 12.8333 34 17.4166 34C19.8 34 20.9 34.9167 22 35.8333C23.1 36.75 24.2 37.6667 26.5833 37.6667C31.1666 37.6667 31.1666 34 35.75 34C38.1333 34 39.2333 34.9167 40.3333 35.8333M3.66663 24.8333C4.76663 25.75 5.86663 26.6667 8.24996 26.6667C12.8333 26.6667 12.8333 23 17.4166 23C19.8 23 20.9 23.9167 22 24.8333C23.1 25.75 24.2 26.6667 26.5833 26.6667C31.1666 26.6667 31.1666 23 35.75 23C38.1333 23 39.2333 23.9167 40.3333 24.8333",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.ae60119055e025593c916527ff75c020.svg";
export { ForwardRef as ReactComponent };